import React from 'react'

class SelectBox extends React.Component {
  handleChange = () => {
    const {
      onChange,
      value,
      currentApplicant
    } = this.props;
    onChange({value, currentApplicant})
  }

  activeClass = () => {
    return(this.props.checked ? 'active' : null)
  }

  render() {
    const {
      value,
      checked,
      name,
      text,
      style
    } = this.props

    return (
      <div
        onClick={ this.handleChange }
        className={`card card-border card-btn ${this.activeClass()} mr-2 ${style}`}
      >
        <div className='custom-control custom-radio'>
          <input
            className='custom-control-input'
            type='radio'
            name={name}
            onChange={ this.handleChange }
            value={value}
            checked={ checked }
          />
          <label className='custom-control-label'>{text}</label>
        </div>
      </div>
    )
  }
}

export default SelectBox;
